import React, { useState } from 'react';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import { getImageBaseUrl } from 'helpers/request';
import Modal from 'components/_utility/Modal/Modal';
import OfferDetailsModal from 'components/OfferDetailsModal';
import ResponsiveImage from 'components/_utility/BackgroundImage/ResponsiveImage';
import { Wrap, Content, Title, InfoIconBtn, Description, ImageWrap } from './OfferBanner.styled';
import useDataLayer from '../../hooks/useDataLayer';

const OfferBanner = ({ offerBanner }) => {
  const { image, long_description: longDescription, short_description: shortDescription, title } = offerBanner;
  const [modalOpen, setModalOpen] = useState(false);
  const pushToDataLayer = useDataLayer();

  return (
    <>
      <Wrap>
        <Content>
          <Title>
            {title}
            <InfoIconBtn
              onClick={() => {
                pushToDataLayer('configuratorOfferInfo');
                setModalOpen(!modalOpen);
              }}
            >
              <InfoIcon />
            </InfoIconBtn>
          </Title>
          <Description>{shortDescription}</Description>
        </Content>
        {image && (
          <ImageWrap>
            <ResponsiveImage
              mobile={getImageBaseUrl() + image?.srcMediumNarrow}
              mobileLarge={getImageBaseUrl() + image?.srcLarge}
              tablet={getImageBaseUrl() + image?.srcMediumNarrow}
              desktop={getImageBaseUrl() + image?.srcSmallSquare}
              alt={image?.altText}
            />
          </ImageWrap>
        )}
      </Wrap>
      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)}>
          <OfferDetailsModal title={title} longDescription={longDescription} />
        </Modal>
      )}
    </>
  );
};

export default OfferBanner;
